module.exports = __webpack_public_path__ + "16b6eadd6050c583de3312973c782e88.pdf";